module.exports = __webpack_public_path__ + "static/img/error-404.94756dcf.svg";